<script setup lang="ts"></script>

<template>
  <icon
    name="svg-spinners:ring-resize"
    class="text-primary-default"
    size="20"
  />
</template>

<style scoped></style>
